













































import moment from 'moment'
import { Component, Vue, Ref } from 'vue-property-decorator'
import ListView from '@/components/ListView.vue'
import CSVExportBtn from '@/components/CSVExport.vue'
import { formatDateForDisplay } from '@/utils'

@Component({
  components: {
    ListView,
    CSVExportBtn,
  },
})
export default class SubscriptionListView extends Vue {
  get headers() {
    return [
      {
        text: this.$t('subscription.text.id'),
        value: 'id',
        width: 80,
        fixed: 'left',
      },
      { text: this.$t('subscription.text.plan'), value: 'planName' },
      { text: this.$t('subscription.text.nextPlan'), value: 'nextPlanName' },
      { text: this.$t('subscription.text.user'), value: 'userEmail' },
      {
        text: this.$t('subscription.text.customerCode'),
        value: 'customerCode',
      },
      { text: this.$t('subscription.text.chargeType'), value: 'chargeType' },
      {
        text: this.$t('subscription.text.chargeExternalId'),
        value: 'chargeExid',
      },
      { text: this.$t('subscription.text.start'), value: 'startAt' },
      { text: this.$t('subscription.text.expires'), value: 'expiringAt' },
      { text: this.$t('subscription.text.updated'), value: 'updated' },
      { text: this.$t('subscription.text.created'), value: 'created' },
    ]
  }
  filterDefinition = {
    search: { type: String, default: null },
  }
  filter: null | Record<string, any> = null
  @Ref() readonly listView!: ListView

  get totalCount() {
    return this.$api.subscriptions().count
  }

  get csvHeaders() {
    const t = this.$t.bind(this)
    return [
      { key: 'id', label: t('subscription.csv.id') },
      { key: 'planName', label: t('subscription.csv.plan') },
      { key: 'nextPlanName', label: t('subscription.csv.nextPlan') },
      { key: 'userEmail', label: t('subscription.csv.user') },
      { key: 'customerCode', label: t('subscription.csv.customerCode') },
      { key: 'chargeType', label: t('subscription.csv.chargeType') },
      { key: 'chargeExid', label: t('subscription.csv.chargeExternalId') },
      {
        key: (item: any) =>
          formatDateForDisplay(item.startAt, this.$i18n.locale),
        label: t('subscription.csv.startDate'),
      },
      {
        key: (item: any) => extractTime(item.startAt),
        label: t('subscription.csv.startTime'),
      },
      {
        key: (item: any) =>
          formatDateForDisplay(item.expiringAt, this.$i18n.locale),
        label: t('subscription.csv.expireDate'),
      },
      {
        key: (item: any) => extractTime(item.expiringAt),
        label: t('subscription.csv.expireTime'),
      },
      {
        key: (item: any) =>
          formatDateForDisplay(item.updated, this.$i18n.locale),
        label: t('subscription.csv.updateDate'),
      },
      {
        key: (item: any) => extractTime(item.updated),
        label: t('subscription.csv.updateTime'),
      },
      {
        key: (item: any) =>
          formatDateForDisplay(item.created, this.$i18n.locale),
        label: t('subscription.csv.createDate'),
      },
      {
        key: (item: any) => extractTime(item.created),
        label: t('subscription.csv.createTime'),
      },
    ]
  }
  get csvFetch() {
    return () => this.$api.subscriptions().list(this.listView.query)
  }

  get staffLoggedIn(): boolean {
    return this.$store.getters.staffLoggedIn
  }

  updateQuery() {
    if (this.filter !== null) this.listView.updateQuery(this.filter)
  }
}

const extractTime = (value: string | undefined) =>
  value ? moment(value).format('HH:mm') : ''
